<template>
  <div>
    <Modal width="600"
           v-model="_value"
           :title="titleDisplay"
           @on-visible-change="visibleChange"
           @on-ok="photoRecordModal_ok"
           ok-text="关闭"
           cancel-text="">

      <div style="position:relative;">
        <Select v-model="maintainid" @on-change="getpicture" @on-open-change="getmaintain">
          <Option v-for="item in maintainpeList" :value="item.id" :key="item.terminalNum">{{item.terminalNum}}</Option>
        </Select>
      </div>

      <div v-if="pictureRecords[currentPictureIndex]" style="text-align: center">
        <label v-if="pictureRecords[currentPictureIndex].picType === 1">【1】</label>
        <label v-if="pictureRecords[currentPictureIndex].picType === 2">【2】</label>
        {{pictureRecords[currentPictureIndex].key }}
        <a @click="onDownloadClick">【下载图片】</a>
      </div>
      <Carousel v-model="currentPictureIndex" v-if="pictureRecords.length>0" style="text-align: center;">
        <CarouselItem v-for="item in pictureRecords">
          <div class="demo-carousel">
            <img @click="onPhotoClick"
                 :src="'https://pic.jianchengjt.com/' + item.picKey + '?imageMogr2/thumbnail/600x400'"></img>
          </div>
        </CarouselItem>
      </Carousel>
      <div style="position:relative;">
        <Table border highlight-row size="small" @on-row-click="onRowClick" height="600" :columns="columns"
               :data="pictureRecords"
               :height="tableHeight" ref="table"></Table>
        <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoading">
          <Spin size="large"></Spin>
          <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
        </div>
      </div>

      <div style="margin-top: 20px;">图片上传</div>
      <div>
        <Select v-model="addPictureRecord.picType" @on-change="loadPhotoRecords(maintainOrderid)">
          <Option v-for="item in picTypeList" :value="item.val" :key="item.val">{{item.name}}</Option>
        </Select>
        <Upload
          :before-upload="handleBeforeUpload"
          action="https://upload-z2.qiniup.com">
          <Button type="default" icon="ios-cloud-upload-outline">选择上传图片</Button>
        </Upload>
        <div v-if="uploadFile !== null">上传文件: {{uploadFile.name}}
          <Button type="text" @click="upload" :loading="loadingStatus">{{loadingStatus?'正在上传':'点击上传文件'}}
          </Button>
        </div>
      </div>
    </Modal>

    <!--<Modal title="图片展示" v-model="visible">-->
    <!--<img :src="'https://o5wwk8baw.qnssl.com/' + imgName + '/large'" v-if="visible" style="width: 100%"></img>-->
    <!--</Modal>-->
  </div>

</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import axios from 'axios'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'VehiclePictureModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      maintainid: '',
      maintainpeList: [],

      currentPictureIndex: 0,

      titleDisplay: '图片管理',

      installOrder: {
        id: null,
        tempVehicleInfo: {
          id: null,
          customName: null,
          vin: null,
          registrationNum: null,
          registrationColor: null,
          vehicleBodyPictureId: null,
          vehicleBodyPicture: null,
          vehicleSrcLicensePicture2Id: null,
          vehicleSrcLicensePicture2: null,
          vehicleSrcLicensePicture1Id: null,
          vehicleSrcLicensePicture1: null,
          certificatePictureId: null,
          certificatePicture: null,
          vehicleLicensePictureId: null,
          vehicleLicensePicture: null,
          vehicleLicenseFlapPictureId: null,
          vehicleLicenseFlapPicture: null,
          qghyptChangeContractPictureId: null,
          qghyptChangeContractPicture: null,
          qghyptChangeAuthorizationPictureId: null,
          qghyptChangeAuthorizationPicture: null,
          idFilePictureId: null,
          idFilePicture: null,
          idFileBackPictureId: null,
          idFileBackPicture: null,
          jtjChangeAuthorizationPictureId: null,
          jtjChangeAuthorizationPicture: null,
          roadTransportationPermitCardPictureId: null,
          roadTransportationPermitCardPicture: null,
          businessLicensePictureId: null,
          businessLicensePicture: null,
          installationCertificatePictureId: null,
          installationCertificatePicture: null
        }
      },

      tableHeight: 160,
      listLoading: false,
      loadingStatus: false,
      pictureRecords: [],
      columns: [
        {
          title: 'picKey',
          key: 'picKey',
          ellipsis: 'true',
          minWidth: 250
        },
        {
          title: '图片类型',
          key: 'picType',
          ellipsis: 'true',
          minWidth: 100,
          render: (h, params) => {
            return h('Select', {
              style: { width: '80px' },
              props: {
                // value: this.data[params.index].volumeType,
                value: params.row.picType,
                disabled: !params.row.modify
              },
              on: {
                'on-change': (event) => {
                  params.row.picType = event
                  console.log(params.row.picType)
                }
              }
            },
            [
              h('Option', {
                props: {
                  value: 1
                }
              }, '1'),
              h('Option', {
                props: {
                  value: 2
                }
              }, '2')
            ]
            )
          }
        }
        //   {
        //   title: '操作',
        //   key: 'action',
        //   align: 'center',
        //   ellipsis: 'true',
        //   minWidth: 250,
        //   render: (h, params) => {
        //     return h('div', [
        //       h('Button', {
        //         props: {
        //           shape: 'circle',
        //           type: 'error',
        //           size: 'small',
        //           disabled: false
        //         },
        //         on: {
        //           click: () => {
        //             this.onDeleteBtnClick(params.row.id)
        //           }
        //         }
        //       }, '删除')]
        //     );
        //   }
        // }
      ],
      addPictureRecord: {
        picKey: null,
        srcHeight: null,
        srcWidth: null,
        picType: 1
      },
      picTypeList: [
        { name: '维修前图片', val: 1 },
        { name: '维修后图片', val: 2 }
      ],
      postParams: {
        upload_token: null
      },
      uploadFile: null
    }
  },
  methods: {
    ...mapActions([
      'PictureServ_GetQiniuUploadToken',
      'PictureServ_AddObj',
      'PictureServ_DeleteObj',
      'InstallOrderServ_GetDetail',
      'InstallOrderServ_ChangePicture'
    ]),
    onRowClick (item, index) {
      this.currentPictureIndex = index
    },
    onDownloadClick () {
      let item = this.pictureRecords[this.currentPictureIndex]
      window.open('https://pic.jianchengjt.com/' + item.picKey + '?attname=' + item.picKey + '.jpg')
    },
    onPhotoClick () {
      let item = this.pictureRecords[this.currentPictureIndex]
      window.open('https://pic.jianchengjt.com/' + item.picKey)
    },
    onDeleteBtnClick (id) {
      // store.dispatch('PictureServ_DeleteObj', {
      //   params: {id: id},
      //   urlparams: null
      // }).then(() => {
      //   this.$Message.success('删除照片成功');
      //   store.dispatch('PictureServ_GetHousePhotos', {
      //     params: {id: this._housingResourceId},
      //     urlparams: null
      //   }).then(() => {
      //     this.pictureRecords = store.getters.get_PhotoRecord_GetHousePhotosResult;
      //   }).catch(err => {
      //     this.$Message.error(err);
      //   });
      // }).catch(err => {
      //   this.$Message.error(err);
      // });
    },
    visibleChange (val) {
      if (val) {
        this.maintainid = ''
        this.uploadFile = null
        this.loadPhotoRecords(this.maintainOrderid)
      }
    },
    upload () {
      console.log('开始上传')
      let param = new FormData() // 创建form对象
      param.append('chunk', '0')// 断点传输
      param.append('chunks', '1')
      param.append('key', this.postParams.picKey)
      param.append('file', this.uploadFile, this.uploadFile.name)
      param.append('token', this.postParams.upload_token)

      let config = {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: false
      }
      this.loadingStatus = true

      axios.post('https://upload-z2.qiniup.com', param, config)
        .then(response => {
          console.log(response.data)
          this.addPictureRecord.picKey = this.postParams.picKey
          store.dispatch('MaintainOrderServ_UploadMaintainPicture', {
            params: {
              id: this.maintainid,
              picKey: this.addPictureRecord.picKey,
              picType: this.addPictureRecord.picType,
              srcWidth: this.addPictureRecord.srcWidth,
              srcHeight: this.addPictureRecord.srcHeight
            },
            urlparams: null
          }).then(() => {
            this.loadingStatus = false
            this.$Message.success('添加图片成功')
            this.uploadFile = null
            this.loadPhotoRecords(this.maintainOrderid)
            this.$emit('on-success')
          }).catch(err => {
            this.loadingStatus = false
            this.$Message.error(err)
          })
        }).catch(err1 => {
          this.$Message.error(err1)
          this.loadingStatus = false
        })
    },
    photoRecordModal_ok () {

    },
    handleView (name) {
      this.imgName = name
      this.visible = true
    },
    handleRemove (file) {
      const fileList = this.$refs.upload.fileList
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1)
    },
    handleSuccess (res, file) {
      file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar'
      file.name = '7eb99afb9d5f317c912f08b5212fd69a'
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: 'The file format is incorrect',
        desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
      })
    },
    handleMaxSize (file) {
      this.$Notice.warning({
        title: 'Exceeding file size limit',
        desc: 'File  ' + file.name + ' is too large, no more than 2M.'
      })
    },
    handleBeforeUpload (file) {
      console.log('handleBeforeUpload')
      store.dispatch('PictureServ_GetQiniuUploadToken', {
        params: { head: 'MAINTAIN' },
        urlparams: null
      }).then(() => {
        this.postParams.upload_token = store.getters.get_Picture_GetQiniuUploadTokenResult.uploadToken
        this.postParams.picKey = store.getters.get_Picture_GetQiniuUploadTokenResult.photoKey
        this.uploadFile = file
        console.log('PictureServ_GetQiniuUploadToken ok')
      }).catch(err => {
        this.$Message.error(err)
      })
      return false
    },
    getmaintain () {
      store.dispatch('MaintainOrderServ_GetDetail', {
        params: { id: this._initValue },
        urlparams: null
      }).then(() => {
        console.log(store.getters.get_MaintainOrder_GetDetailResult)
        if (store.getters.get_MaintainOrder_GetDetailResult) {
          this.maintainpeList = store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords
          // this.MaintainPicture.id = store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords[0].id
        }
        console.log(this.maintainpeList)
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    getpicture (e) {
      this.maintainOrderid = e
      this.loadPhotoRecords(this.maintainOrderid)
    },
    loadPhotoRecords (e) {
      this.pictureRecords = []
      store.dispatch('MaintainOrderServ_GetDetail', {
        params: { id: this._initValue },
        urlparams: null
      }).then((res) => {
        // console.log(res)
        let title = null
        let MaintainOrder = store.getters.get_MaintainOrder_GetDetailResult
        if (MaintainOrder.maintainDeviceRecords != null) {
          let maintainDeviceRecords = MaintainOrder.maintainDeviceRecords
          for (let i = 0; i < maintainDeviceRecords.length; i++) {
            // console.log(maintainDeviceRecords[i])
            // console.log(e)
            console.log(this.addPictureRecord.picType)
            if (this.addPictureRecord.picType == 1) {
              if (e == maintainDeviceRecords[i].id) {
                for (let j = 0; j < maintainDeviceRecords[i].beforePics.length; j++) {
                  console.log(maintainDeviceRecords[i].beforePics[j])
                  this.pictureRecords.push(maintainDeviceRecords[i].beforePics[j])
                }
              }
            }
            if (this.addPictureRecord.picType == 2) {
              if (e == maintainDeviceRecords[i].id) {
                for (let j = 0; j < maintainDeviceRecords[i].afterPics.length; j++) {
                  console.log(maintainDeviceRecords[i].afterPics[j])
                  this.pictureRecords.push(maintainDeviceRecords[i].afterPics[j])
                }
              }
            }
          }
        }
        console.log(this.pictureRecords)
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  mounted () {
    // this.uploadList = this.$refs.upload.fileList;
    // store.dispatch('MaintainOrderServ_GetDetail', {
    //   params: { id: this._initValue },
    //   urlparams: null
    // }).then(() => {
    //   console.log(store.getters.get_MaintainOrder_GetDetailResult)
    //   if (store.getters.get_MaintainOrder_GetDetailResult) {
    //     this.maintainpeList = store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords
    //     // this.MaintainPicture.id = store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords[0].id
    //   }
    //   console.log(this.maintainpeList)
    // }).catch(err =>{
    //   this.$Message.error(err)
    // })
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  }
}
</script>

<style scoped>
  .demo-upload-list {
    display: inline-block;
    width: 120px;
    height: 120px;
    text-align: center;
    line-height: 120px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    margin-right: 4px;
  }

  .demo-upload-list img {
    width: 100%;
    height: 100%;
  }

  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
  }

  .demo-upload-list:hover .demo-upload-list-cover {
    display: block;
  }

  .demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }

  .demo-carousel {
    height: 400px;
    width: 600px;
    /*line-height: 200px;*/
    text-align: center;
    color: #fff;
    font-size: 20px;
    background-color: #506b9e;
  }

  .demo-carousel img {
    height: 400px;
    width: 600px;
  }
</style>
